(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    // --- helpers: query string (statt URLSearchParams) ---
    function getQueryParam(name) {
      var query = window.location.search || "";
      if (query.charAt(0) === "?") query = query.substring(1);
      var parts = query.split("&");
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split("=");
        if (decodeURIComponent(kv[0] || "") === name) {
          return decodeURIComponent((kv[1] || "").replace(/\+/g, " "));
        }
      }
      return null;
    }

    var utmSource = getQueryParam("utm_source") || localStorage.getItem("utm_source") || "";
    if (utmSource !== "meta" && utmSource !== 'facebook') return;

    localStorage.setItem("utm_source", "meta");

    // --- mapping (ohne Object.freeze) ---
    var MAPPING = {
      tempixque: "https://cdn.shopify.com/s/files/1/0899/9652/5916/files/Tempixque2.png",
      esperanza: "https://cdn.shopify.com/s/files/1/0899/9652/5916/files/Esperanza_4bf33c09-a6fb-43ec-9214-81a472166cd8.png",
      "nossa-senhora":
        "https://cdn.shopify.com/s/files/1/0899/9652/5916/files/Nossa_Senhora_44dc545a-c8b1-4156-bdb1-4c0ab537b35a.png",
      "tega-tula":
        "https://cdn.shopify.com/s/files/1/0899/9652/5916/files/Tega_Tula_53e9c1b7-b8bd-462e-a612-2e867e767a80.png",
      "pacha-mama": "https://cdn.shopify.com/s/files/1/0899/9652/5916/files/Pacha_Mama.png",
    };

    // --- main ---
    var productModalOpener = document.querySelector(".js-productModalOpener");
    if (!productModalOpener) return;

    // dataset fallback
    var handle =
      (productModalOpener.getAttribute("data-product-handle") ||
        (productModalOpener.dataset && productModalOpener.dataset.productHandle) ||
        "") + "";

    handle = handle.toLowerCase();

    // "has own" fallback
    if (!handle || !Object.prototype.hasOwnProperty.call(MAPPING, handle)) return;

    // --- helpers: URL handling (statt new URL) ---
    function getQueryPart(url) {
      var qIndex = url.indexOf("?");
      return qIndex === -1 ? "" : url.substring(qIndex); // includes '?'
    }

    function getBasePart(url) {
      var qIndex = url.indexOf("?");
      return qIndex === -1 ? url : url.substring(0, qIndex);
    }

    function resolveToAbsolute(url) {
      // turns //cdn.. or /path.. into absolute via an <a>
      var a = document.createElement("a");
      a.href = url;
      // For protocol-relative URLs (//...), older browsers sometimes need explicit protocol:
      if (url && url.indexOf("//") === 0) a.href = window.location.protocol + url;
      return a.href;
    }

    function withOriginalQuery(newBaseUrl, originalUrl) {
      var origAbs = resolveToAbsolute(originalUrl);
      var baseAbs = resolveToAbsolute(newBaseUrl);
      var origQuery = getQueryPart(origAbs);
      return getBasePart(baseAbs) + origQuery;
    }

    function replaceSrcsetBase(newBaseUrl, srcset) {
      if (!srcset) return srcset;

      var parts = srcset.split(",");
      var out = [];
      for (var i = 0; i < parts.length; i++) {
        var candidate = parts[i].replace(/^\s+|\s+$/g, "");
        if (!candidate) continue;

        // split into url + descriptor (e.g. "493w")
        var firstSpace = candidate.search(/\s/);
        var urlPart = firstSpace === -1 ? candidate : candidate.slice(0, firstSpace);
        var descriptor = firstSpace === -1 ? "" : candidate.slice(firstSpace).replace(/^\s+|\s+$/g, "");

        var newUrl = withOriginalQuery(newBaseUrl, urlPart);
        out.push(descriptor ? newUrl + " " + descriptor : newUrl);
      }
      return out.join(", ");
    }

    var imgSrc = MAPPING[handle];
    var imgElement = productModalOpener.querySelector("img");

    if (imgElement) {
      var currentSrc = imgElement.getAttribute("src") || imgElement.src || "";
      var currentSrcset = imgElement.getAttribute("srcset") || imgElement.srcset || "";

      if (currentSrc) imgElement.src = withOriginalQuery(imgSrc, currentSrc);
      if (currentSrcset) imgElement.srcset = replaceSrcsetBase(imgSrc, currentSrcset);
    }

    // prevent click reliably (no addEventListener options)
    productModalOpener.style.pointerEvents = "none";

    var clickHandler = function (e) {
      e = e || window.event;
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;

      if (e.stopPropagation) e.stopPropagation();
      e.cancelBubble = true;

      return false;
    };

    productModalOpener.addEventListener("click", clickHandler, true); // capture = true (old-school)

    var style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML =
      "@media screen and (max-width: 525px) { .pdp-gallery-side__gallery { max-width: 100vw !important; } .slider.slider--mobile { margin-bottom: 0px !important; } .breadcrumb-nav { margin-bottom: 0px !important; } }";
    document.getElementsByTagName("head")[0].appendChild(style);
  });
  } catch(e) { console.error(e); }
})();

})();
